import * as FilePond from 'filepond';
import { filepondTranslations } from '../translations/filepond.nl';

const fileUpload = (options) => {
    return {

        pond: null,
        disableSubmit: false,

        init() {
            const { inputSelector, propertySelector } = options;
            if (!inputSelector || !propertySelector) {
                console.warn('No validation configuration provided.');
            }

            const inputElement = document.querySelector(inputSelector);
            const validationElement = document.querySelector(`[data-valmsg-for="${propertySelector}"]`);
            const shadowPropertyElement = document.querySelector(`[name="${propertySelector}"]`);
            const submitElement = this.$el.closest('form').querySelector('button[type="submit"]');

            this.pond = FilePond.create(inputElement);

            this.pond.onupdatefiles = (_) => {
                validationElement.innerText = '';
                this.disableSubmit = false;
            };

            this.setEventListeners(this.pond);
            this.$watch('disableSubmit', (disableSubmit) => {
                if (disableSubmit) {
                    submitElement.setAttribute('disabled', 'disabled');
                } else {
                    submitElement.removeAttribute('disabled');
                }
            });

            FilePond.setOptions({
                server: {
                    url: window.location.origin,
                    process: {
                        url: '/api/internal/upload',
                        method: 'POST',
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest'
                        },
                        withCredentials: false,
                        onload: (response) => {
                            shadowPropertyElement.value = response;
                            return response;
                        },
                        onerror: (response) => {
                            if (response) {
                                const errorMessages = JSON.parse(response);
                                this.pond.setOptions({
                                    labelFileProcessingError: errorMessages[0]
                                });
                            }
                            return response.data;
                        }
                    },
                    revert: {
                        url: '/api/internal/upload',
                        method: 'DELETE',
                        withCredentials: false
                    }
                },
                ...filepondTranslations
            });
        },

        setEventListeners(pond) {
            pond.on('processfilestart', (file) => {
                this.disableSubmit = true;
            });

            pond.on('processfileabort', (file) => {
                this.disableSubmit = false;
            });

            pond.on('processfile', (error, file) => {
                if (error) {
                    this.disableSubmit = true;
                } else {
                    this.disableSubmit = false;
                }
            });

            pond.on('processfilecomplete', (file) => {
                this.disableSubmit = false;
            });
        }

    };
};

export { fileUpload };